jQuery('document').ready(function ($) {
    var Loading = $('.loading');
    var ImgLoading = $('.image_loading');
    var Body = $('body');
    function getCookie(cookie) {
        return document.cookie.split(';').reduce(function (prev, c) {
            var arr = c.split('=');
            return (arr[0].trim() === cookie) ? arr[1] : prev;
        }, undefined);
    }
    if (getCookie('loading') >= '1') {
        Loading.addClass('isNone');
    }
    else {
        Loading.fadeIn();
        ImgLoading.fadeIn();
        Body.addClass('noScroll');
    }
    setTimeout(function () {
        var Cook = 'loading=1';
        document.cookie = Cook;
        Loading.delay(3600).fadeOut(100);
        ImgLoading.delay(3000).fadeOut(600);
        Body.removeClass('noScroll');
    }, 3000);
    var Imglogo = $('.iconImgLogo');
    function scrollFunction() {
        if (document.body.scrollTop > 35 || document.documentElement.scrollTop > 35) {
            Imglogo.addClass('smallimg');
        }
        else {
            Imglogo.removeClass('smallimg');
        }
    }
    window.onscroll = function () {
        scrollFunction();
    };
    // if (arrayCookie[0] === 'loading=1'){
    // }else{
    //     Loading.delay(3900).fadeIn(100);
    //     ImgLoading.delay(4300).fadeIn(800);
    //     setTimeout(() => {
    //         let Cook = 'loading=1';
    //         document.cookie = Cook;
    //         Loading.removeClass('isShow');
    //     }, 4500);
    // }
    // if(!Loading.hasClass('isShow')){
    //     Body.toggleClass('noScroll').delay(2000).removeClass('noScroll');
    // }
    var menu = $('.menu_container');
    var subMenu = $('.submenu');
    var close = $('.close');
    var open = $('.sub_open');
    var burguer = $('.menu__burger');
    open.on('click', function () {
        if (!subMenu.hasClass('click')) {
            subMenu.toggleClass('click');
            $('body').toggleClass('noScroll');
            open.addClass('bold');
        }
        else {
            subMenu.toggleClass('click');
            $('body').toggleClass('noScroll');
            open.removeClass('bold');
        }
    });
    close.on('click', function () {
        if (!subMenu.hasClass('click')) {
            subMenu.toggleClass('click');
            $('body').toggleClass('noScroll');
            open.addClass('bold');
        }
        else {
            subMenu.toggleClass('click');
            $('body').toggleClass('noScroll');
            open.removeClass('bold');
        }
    });
    burguer.on('click', function () {
        if (!subMenu.hasClass('click')) {
            subMenu.toggleClass('click');
            $('body').toggleClass('noScroll');
            open.removeClass('bold');
        }
        else {
            subMenu.toggleClass('click');
            $('body').toggleClass('noScroll');
            open.removeClass('bold');
        }
    });
    // let scrollUp = false;
    // let scrollDown = false;
    // $('body').on('mousewheel DOMMouseScroll', function(e){        
    //     if(typeof e.originalEvent.detail == 'number' && e.originalEvent.detail !== 0) {
    //       if(e.originalEvent.detail > 0) {
    //         // console.log('Down');
    //         scrollUp = false;
    //         scrollDown = true;
    //       } else if(e.originalEvent.detail < 0){
    //         //   console.log('Up');
    //           scrollUp = true;
    //           scrollDown = false;
    //       }
    //     } else if (typeof e.originalEvent.wheelDelta == 'number') {
    //       if(e.originalEvent.wheelDelta < 0) {
    //         //   console.log('Down');
    //           scrollUp = false;
    //           scrollDown = true;
    //       } else if(e.originalEvent.wheelDelta > 0) {
    //         //   console.log('Up');
    //           scrollUp = true;
    //           scrollDown = false;              
    //       }
    //     }
    //   });
    //   let logo = $('.icon_logo img');
    //   let _watchUp = null;
    //   setInterval(function() {
    //       if ( _watchUp !== scrollUp ) {
    //           _watchUp = scrollUp;
    //           if (scrollUp == true) {
    //                 if(logo.hasClass('smallimg')){
    //                     logo.toggleClass('smallimg');
    //                 }
    //                 //menu.css('transform','translateY(0%)');
    //                 // console.log('scroll up', scrollUp);
    //           }
    //       }
    //   }, 100);
    //   let _watchDown = null;
    //   setInterval(function() {
    //       if ( _watchDown !== scrollDown ) {
    //           _watchDown = scrollDown;
    //           if (scrollDown == true) {
    //                 // menu.css('transform','translateY(-100%)');
    //                 // console.log('scroll down', scrollDown);
    //           }
    //       }
    //   }, 100);
});
